import React, { useRef } from "react";
import { Form, Col, Button, Row } from "react-bootstrap";
import { BfButtonBlue, BfButtonBlueSecondary } from "../../../Styling/styledForm/styledBlueForm";
import {
    StyledModal,
    StyledModalBody,
    StyledModalFooter,
} from "../../../Styling/styledModal/styledModals";
import { useNavigate } from 'react-router-dom';



// Eksempel på file upload i react
// https://www.geeksforgeeks.org/file-uploading-in-react-js/

// Det finnes eksempler på hvordan man kan kommer rundt styling av knapp for upload

const MeldingModal = (props) => {

    const localeMessages = props.funcs.localeMessages
    
    let btnRef = useRef();
    const navigate = useNavigate();
    const showInfo = props.showInfo;

    return (

        <StyledModal centered show={true} onHide={props.funcs.cancelHandler} size="xl" >

            <StyledModalBody>
                {props.funcs.taskId && <h4>{localeMessages["ML1M_Overskrift_svar"]}</h4>}
                {showInfo ? (
                    <p>Vi opplever at kunder ikke kan se meldinger de har mottatt her, vennligst gå til Oversikt &rarr; Oppgaver og trykk på Svar-knappen for å besvare denne meldingen. Du kan finne dine besvarte meldinger under Oversikt &rarr; Besvarte.</p>
                ) : (
                <>
                {!props.funcs.taskId && <h4>{localeMessages["ML1M_Overskrift_ny"]}</h4>}
                {props.samleSakStatus === 'Undersak' && <h4 style={{color:'red'}}>{localeMessages["ML1M_Undersak"]}</h4>}
                <Form.Group>     

                    <Form.Label>{localeMessages["ML1M_sak"]}</Form.Label>
                    <div>{props.funcs.getM1Tekst()}</div>

                    {props.funcs.taskId && <>
                        <Form.Label>{localeMessages["MS1M_melding"]}</Form.Label>
                        <Form.Control id="Oppgave" name="meldingstekst" as="textarea" rows={8} readOnly style={{ backgroundColor: '#ffd7ba', whiteSpace: 'pre-line'}}
                            value={props.funcs.orgMessage}
                        />
                    <div>&nbsp;</div> 
                    </>}


                        {props.funcs.taskId && <Form.Label column="sm" lg={4}>{localeMessages["ML1M_oppgave_s"]}</Form.Label>}
                        {!props.funcs.taskId && <Form.Label column="sm" lg={4}>{localeMessages["ML1M_oppgave_m"]}</Form.Label>}
                        <Col>
                             <Form.Control id="Oppgave" name="Oppgave" as="textarea" rows={12} 
                                value={props.funcs.oppgave} onChange={(e) => props.funcs.setOppgave(e.target.value)}                                
                             />
                        </Col>

                        <Form.Label column="sm" lg={4}>

                        </Form.Label>
                        <Col>
                            <input type="file" onChange={props.funcs.onUploadFileChange} />
                        </Col>

                </Form.Group>
                </>
                )}

            </StyledModalBody>

            <StyledModalFooter>
                {showInfo ? (
                    <BfButtonBlue
                        onClick={() => {props.funcs.cancelHandler(); navigate('/Overview');}}>
                        Til Oversikt
                    </BfButtonBlue>
                ) : (
                    <BfButtonBlue
                        ref={btnRef}
                        disabled={props.funcs.validates()}
                        onClick={props.funcs.okHandler}>
                        {localeMessages["ML1M_Ok"]}
                    </BfButtonBlue>
                )}
                <BfButtonBlueSecondary textAsBorder blackBorder onClick={props.funcs.cancelHandler}>
                    {localeMessages["ML1M_Avbryt"]}
                </BfButtonBlueSecondary>

            </StyledModalFooter>

        </StyledModal>
    );
};

export default MeldingModal;